import * as React from 'react';
import Footer from '../../components/footer/Footer';

import '../../assets/style.css';
import '../../assets/style_home.css';

import Section from '../../components/section/Section';
import Navbar from '../../components/nav/Navbar';
import {isBrowser, isMobile } from 'react-device-detect';
import { FormDataBuilder, makeFormControls } from '../../components/formElements/util';
import zupanije from '../../assets/zupanije_arr';
import { api } from '../../environment';
import Form from '../../components/formElements/Form';
import WeekList from '../../components/layouts/WeekList';
import axios from 'axios';
export default function EventView(){

    let formDataBuilder = new FormDataBuilder();
    const [city, setCity] = React.useState('-1');
    const [cities, setCities] = React.useState([]);
    const [data, setData] = React.useState(null);

    const getDataPhuck = ()=>{
        let call = fetch(api+"/get_week_activities",{
                                method: "POST",
                                body:JSON.stringify(
                                    {name:city})
                                })
        
                    try{
                        call.then((response)=> response.json().then(data=>{
                                setData(()=>{
                                    return data['data']
                                })
                    }))

                    } catch(err){
                        console.log(err);
                        return []
                    }
    }

    React.useEffect(()=>{
        let call = fetch(api+"/get_active_cities",{
                                method: "GET",})
        try{
                call.then((response)=> response.json().then(data=>{
                                setCities(()=>{
                                    return data['result']
                                })

                    }))
                    } catch(err){
                        console.log(err);
                        return []
                    }

        if(city!='-1'){
            console.log('SUCCESS')
        getDataPhuck();
        } 
    
    }, [city])

    return (
        <>
        <Navbar elements={[
        {
            text: 'Naslovna',
            link: '/',
            key: 'naslovna'
        },
        /*{
            text: 'Novosti',
            link: '/novosti',
            key: 'novosti'
        },*/
        {
            text: 'Prijava aktivnosti',
            link: '/prijava',
            key: 'prijava'
        },
        {
            text: 'Pregled aktivnosti',
            link: '/pregled',
            key: 'pregled'
        },

    ]}/>
    <div className="content">
    <Section title={<div style={{textAlign:"right"}} className="section-title-font">Pregled aktivnosti</div>} 
    content={<div style={{textAlign:"center"}}>
            <div style={{width:"50%", textAlign:"center", margin:"auto"}}>
              <h2>Odabir grada</h2> 
               <ul id="cities-container">
                   {
                    cities.map((city, index)=>{
                       return <li class="city-element" key={index} onClick={(e)=>{
                            setCity(()=>{
                                return city.value
                            }  )
                       }  } >{city.text} 
                       </li>
                    }  )
                   } 
            </ul>    
        </div>
        
        </div>}
    />
    
    <WeekList data={data}></WeekList>
    
    </div>
    <Footer></Footer> 
    </>
    )
}